export default __webpack_public_path__ + "static/media/tank-nobg.487cba2f.png";